<template>
  <div class="flex w-full flex-col bg-white  border-gray-100 rounded-2xl mt-0">
    <!-- Section Header -->
   

    <!-- Table Container -->
    <div class="w-full rounded-xl border shadow-sm overflow-x-auto relative min-h-custom">
      <!-- Loading Overlay -->
      <div 
        v-if="isLoading" 
        class="absolute min-h-custom bg-white inset-0 bg-white/70 z-10 flex items-center justify-center rounded-xl"
      >
            <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center">
        <svg class="h-26 w-16 animate-spin text-blue-600 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none"
          viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"></circle>
          <path d="M12 2 A 10 10 0 0 1 22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path>
        </svg>
      </div>
      </div>
      <table class="w-full text-left border-collapse">
        <thead>
          <tr class="border-b bg-gray-50  border-gray-200 text-xs font-medium text-gray-500 uppercase bg-gray-50/50">
            <th class="py-3 px-3 rounded-l-lg">No</th>
            <th class="py-3 px-3">TAG LOCATIONS</th>
            <th class="py-3 px-3 text-left">scan</th>
            <th class="py-3 px-3 text-left">visitor</th>
             <th class="py-3 px-3 text-left">Reader</th>
          </tr>
        </thead>
        <tbody class="divide-y  divide-gray-100 text-sm font-medium text-gray-800">
          <!-- Data Rows -->
           
          <tr 
            v-for="(location, index) in locations" 
            :key="location.id || index"
            class="hover:bg-gray-50/80 transition-colors"
          >
            <td class="py-3 px-3 text-gray-500 font-normal">
              {{ index + 1 }}
            </td>
           <td style="width: 150px;" class="py-3.5 px-3 font-normal text-gray-500 truncate">
  {{ location.tag_location || '-' }}
</td>
            <td class="py-3 px-3 text-left text-gray-500">
              {{ location.scan ?? 0 }}
            </td>
            <td class="py-3 px-3 text-left  text-gray-500">
              {{ location.visitor ?? 0 }}
            </td>
             <td class="py-3 px-3 text-left  text-gray-500">
              {{ location.reader ?? 0 }}
            </td>
          </tr>

          <!-- Empty State Row -->
          <tr v-if="!isLoading && locations.length === 0">
            <td colspan="5" class="py-8 text-center text-gray-400 text-sm">
              <div class="flex flex-col items-center justify-center space-y-2">
                 <div
          class="flex h-36 justify-center w-full flex-col items-center space-y-2 rounded-xl">
          <div>
<img src="../../assets/img/empty_smartpin.png" class=" w-12" alt="" /> 
          </div>
          <p class="text-sm text-center font-medium text-gray-800">No Data Yet</p>
           <p class="text-xs m-0 text-center font-normal text-gray-500">Client has no activity yet.</p>
        </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopLocationsTable',
  props: {
    locations: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    selectedDateRange: {
      type: Array,
      default: () => [new Date(), new Date()]
    }
  },
  data() {
    return {
      monthNames: [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ]
    };
  },
  computed: {
    formattedDateRange() {
      if (!this.selectedDateRange || !this.selectedDateRange[0]) return '';
      
      const start = new Date(this.selectedDateRange[0]);
      const end = this.selectedDateRange[1] ? new Date(this.selectedDateRange[1]) : start;

      const formatD = (d) => `${d.getDate()} ${this.monthNames[d.getMonth()]} ${d.getFullYear()}`;
      
      if (start.toDateString() === end.toDateString()) {
        return formatD(start);
      }
      return `${formatD(start)} - ${formatD(end)}`;
    }
  },
};
</script>
<style scoped>
.min-h-custom {
  min-height: 300px;
}
</style>